import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update'
import { Capacitor } from '@capacitor/core'

export async function checkForAppUpdate() {
  // Only runs on the native Android app, never on web
  if (Capacitor.getPlatform() !== 'android') return

  try {
    const info = await AppUpdate.getAppUpdateInfo()

    if (info.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) return

    // Immediate = full-screen blocking update (best for important releases)
    if (info.immediateUpdateAllowed) {
      await AppUpdate.performImmediateUpdate()
    } else if (info.flexibleUpdateAllowed) {
      // Flexible = downloads in background, user keeps using the app
      await AppUpdate.startFlexibleUpdate()
      await AppUpdate.completeFlexibleUpdate()
    } else {
      // Fallback — just open the Play Store listing
      await AppUpdate.openAppStore()
    }
  } catch (e) {
    // Silent fail — never block app startup over an update check
    console.log('App update check skipped:', e)
  }
}